import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import * as Sentry from '@sentry/react';

import './index.css';
import { sentryDSN } from './config';

Sentry.init({
  debug: process.env.NODE_ENV === 'development',
  dsn: sentryDSN,
});

ReactDOM.render(<App />, document.getElementById('root'));
